import { useSession } from 'next-auth/react';
import Link from 'next/link';

import { Heading } from '@/ui-lib/heading';
import { Logo } from '@/ui-lib/logo';

interface CartLayoutProps {
    banner?: React.ReactNode;
    leftColumn: React.ReactNode;
    rightColumn: React.ReactNode;
    overlay?: React.ReactNode;
    dialogs?: React.ReactNode;
}

export function CartHeading({ children }: { children: React.ReactNode }) {
    return (
        <Heading variant="page-title" className="text-neutral-100 pb-6 text-md">
            {children}
        </Heading>
    );
}

export function CartLayout({ banner, leftColumn, rightColumn, overlay, dialogs }: CartLayoutProps) {
    const session = useSession();
    return (
        <>
            <div className="min-h-screen w-full bg-neutral-950">
                <div className="max-w-7xl mx-auto px-4 py-8">
                    <div className="mb-8">
                        <Link
                            className="flex items-center gap-x-2 h-[32px] inline-block"
                            href={session.status === 'authenticated' ? '/platform' : '/'}
                        >
                            <Logo color="white" size="md" />
                        </Link>
                    </div>

                    {banner && <div className="mb-6">{banner}</div>}

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        <div className="space-y-4">{leftColumn}</div>
                        <div className="space-y-4">{rightColumn}</div>
                    </div>
                </div>

                {overlay}
            </div>

            {dialogs}
        </>
    );
}
